import { X } from "lucide-react";
import React from "react";
import IconButton from "../../../IconButton";
import { BaseSidebarCloseButton } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function SidebarCloseButton(_ref) {
  var onClick = _ref.onClick,
    tooltipContent = _ref.tooltipContent;
  return /*#__PURE__*/_jsx(BaseSidebarCloseButton, {
    children: /*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(X, {}),
      size: "compact",
      tooltipContent: tooltipContent,
      onClick: onClick
    })
  });
}
export default SidebarCloseButton;